import 'aos/dist/aos.css';
import Aos from "aos";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ScrollToTopRouter} from "./components/router/router";
import {useEffect} from "react";
import {AdminsLoginScreen} from "./screens/admins/account/login";
import {AdminsDashboardArch} from "./arch/admin";
import {AdminsOverviewScreen} from "./screens/admins/overview/overview";
import {RedirectTo} from "./components/router/redirect";
import {AdminsStudentsListScreen} from "./screens/admins/students/list";
import {AdminStudentDetailsScreen} from "./screens/admins/students/details";
import {AdminAttendOverviewScreen} from "./screens/admins/attend/attend";
import {AdminsAttendReportsScreen} from "./screens/admins/attend/reports";
import {ParentsLoginScreen} from "./screens/parents/login/login";
import {StudentsDashboardArch} from "./arch/students";
import {StudentsOverviewScreen} from "./screens/parents/overview/overview";
import {AdminFinanceScreen} from "./screens/admins/finance/finance";
import {AdminStoreScreen} from "./screens/admins/store/store";
import {AdminNewsScreen} from "./screens/admins/news/news";
import {AdminWebsiteScreen} from "./screens/admins/website/website";
import {AdminFormsScreen} from "./screens/admins/forms/forms";
import {AdminTicketsScreen} from "./screens/admins/tickets/tickets";
import {AdminSettingsScreen} from "./screens/admins/settings/settings";
import {AdminCenterScreen} from "./screens/admins/center/center";
import {AdminClassesScreen} from "./screens/admins/classes/classes";
import {StudentsTuitionScreen} from "./screens/parents/tuition/tuition";
import {StudentsTuitionPayInvoiceScreen} from "./screens/parents/tuition/invoice";
import {StudentsTuitionPaidInvoiceScreen} from "./screens/parents/tuition/invoice-paid";
import {StudentsStoreScreen} from "./screens/parents/store/store";
import {StudentsAttendScreen} from "./screens/parents/attend/attend";
import {StudentsNewsScreen} from "./screens/parents/news/news";
import {StudentsTicketsScreen} from "./screens/parents/tickets/tickets";
import {AdminsFinanceTuitionPaymentsScreen} from "./screens/admins/finance/tuition-payments";
import {AdminsPrintFinanceTuitionScreen} from "./screens/admins/print/finance-tuition";
import {AdminFinanceThoseWhoPaidFullyScreen} from "./screens/admins/finance/fully-paid";
import {AdminsPrintThoseWhoFullyPaid} from "./screens/admins/print/full-paid";
import {AdminFinanceThoseWhoStillOweScreen} from "./screens/admins/finance/still-owe";
import {AdminsPrintThoseWhoStillOwe} from "./screens/admins/print/still-owe";
import {AdminsPrintStudentByClassScreen} from "./screens/admins/print/students";
import {AdminsStudentsTuitionPaidInvoiceScreen} from "./screens/admins/finance/paid-invoice";
import {AdminsFinanceTuitionPaymentsOnlineScreen} from "./screens/admins/finance/tuition-payments-online";
import {AdminsFinanceRemindersListScreen} from "./screens/admins/finance/reminders";
import {AdminPrintRemindersScreen} from "./screens/admins/print/reminders";
import {PrintStudentTuitionScreen} from "./screens/admins/print/student-tuition";
import {AdminsTicketViewScreen} from "./screens/admins/tickets/view-ticket";
import {StudentsViewTicketScreen} from "./screens/parents/tickets/view-ticket";
import {StudentsStoreInvoiceScreen} from "./screens/parents/store/store-invoice";
import {AdminsStoreListStudentsWithBudget} from "./screens/admins/store/with-budget";
import {AdminsPrintStudentsWithStoreBudget} from "./screens/admins/print/store-with-budget";
import {AdminsStoreListSalesScreen} from "./screens/admins/store/sales";
import {AdminsPrintStoreSalesScreen} from "./screens/admins/print/store-sales";
import {AdminsStoreListOnlinePaymentsScreen} from "./screens/admins/store/onlines";
import {AdminsPrintStoreOnlinePayments} from "./screens/admins/print/store-online";
import {StudentsProfileScreen} from "./screens/parents/profile/profile";
import {AdminsFinanceLogsListScreen} from "./screens/admins/finance/logs-list";
import {AdminsAttendAbsentsScreen} from "./screens/admins/attend/absents";
import {AdminsCenterClassDetailsScreen} from "./screens/admins/center/sci-class";
import {StudentsCenterScreen} from "./screens/parents/center/center";
import {StudentsCenterClassViewScreen} from "./screens/parents/center/class-view";
import {AdminsExtraPaymentsListScreen} from "./screens/admins/extra/extra-list";
import {AdminsExtraPaymentViewScreen} from "./screens/admins/extra/view-extra";
import {StudentsExtraPaymentInvoiceScreen} from "./screens/parents/extra/extra-invoice";
import {StudentsSciCenterInvoiceScreen} from "./screens/parents/center/sci-invoice";
import {AdminsNewsDetailsScreen} from "./screens/admins/news/news-details";
import {StudentsViewNewsScreen} from "./screens/parents/news/get-news";
import {AdminsPrintExtraPaymentsScreen} from "./screens/admins/print/extra-payment";
import {AdminsConsentsListScreen} from "./screens/admins/consents/consent-list";
import {Error404Page} from "./screens/error/404";
import {AdminsConsentDetailsScreen} from "./screens/admins/consents/view-consent";
import {AdminsPrintConsentSignupsScreen} from "./screens/admins/print/consent";
import {StudentsConsentsListScreen} from "./screens/parents/consents/consent-list";
import {StudentsViewConsentScreen} from "./screens/parents/consents/view-consent";
import {HomeScreen} from "./screens/home/home";
import {AdminsPrintConsentPaperScreen} from "./screens/admins/print/consent-paper";
import {AdminUsersScreen} from "./screens/admins/users/users";
import {AdminsStaffScreen} from "./screens/admins/staff/staff";
import {AdminsPresignupScreen} from "./screens/admins/presignup/presignup";
import {AdminsPresignupInsightsScreen} from "./screens/admins/presignup/insights";
import {HomeArchitecture} from "./arch/home";
import {HomeNewsScreen} from "./screens/home/news/news";
import {HomeNewsViewScreen} from "./screens/home/news/view-news";
import {HomeAboutSignupScreen} from "./screens/signup/about-signup";
import {HomeReportsScreen} from "./screens/home/reports/reports";
import {HomeReportViewScreen} from "./screens/home/reports/report-view";
import {HomeAboutScreen} from "./screens/home/about/about";
import {HomeNahalBankScreen} from "./screens/home/bank-nahal/bank";
import {SignupLoginScreen} from "./screens/signup/login";
import {SignupStatusScreen} from "./screens/signup/status";
import {SignupInvoiceScreen} from "./screens/signup/invoice";
import {StudentsPresignupAutoLoginScreen} from "./screens/parents/signup/signup";
import {HomeGalleryScreen} from "./screens/home/gallery/gallery";
import {AdminsPresignupStudentDetails} from "./screens/admins/presignup/student-details";
import {AdminsSignupPrintStudents} from "./screens/admins/print/signup-print";
import {HomeHonorsScreen} from "./screens/home/honors/honors";
import { AdminsConsultOverviewScreen } from './screens/admins/consult/consult-overview';
import {AdminsConsultRequestsScreen} from "./screens/admins/consult/requests";
import {AdminsConsultRequestViewScreen} from "./screens/admins/consult/request-view";
import {AdminsConsultProfilesList} from "./screens/admins/consult/consult-profiles";
import {AdminsConsultProfileViewScreen} from "./screens/admins/consult/view-profile";
import {StudentsConsultOverviewScreen} from "./screens/parents/consult/consult";
import {ParentsConsultRequestViewScreen} from "./screens/parents/consult/view-request";
import {AdminsStaffDetailsScreen} from "./screens/admins/staff/staff-details";
import {AdminsStaffJobsScreen} from "./screens/admins/staff/jobs";
import {AdminsStaffSalariesScreen} from "./screens/admins/staff/salaries";
import {AdminsStaffRequestsScreen} from "./screens/admins/staff/requests";
import {AdminsStaffRequestDetailsScreen} from "./screens/admins/staff/request-details";
import {AdminsStaffHireScreen} from "./screens/admins/staff/hire";
import {AdminsHireViewJobScreen} from "./screens/admins/staff/hire-view-job";
import {AdminsStaffAttendOverview} from "./screens/admins/staff/attend";
import {AdminsStaffAttendAbsentsScreen} from "./screens/admins/staff/attend-absents";
import {AdminsStaffPrintContractScreen} from "./screens/admins/staff/print-contract";

export const App = (props: { lang: string }) => {
    useEffect(() => {
        Aos.init({once: true});
    }, []);
    return (
        <>
            <BrowserRouter>
                <ScrollToTopRouter/>
                <Routes>
                    <Route path="/" element={<HomeArchitecture/>}>
                        <Route path="" element={<HomeScreen/>}/>
                        <Route path="news" element={<HomeNewsScreen/>}/>
                        <Route path="news/view/:newsNd" element={<HomeNewsViewScreen/>}/>
                        <Route path="signup" element={<HomeAboutSignupScreen/>}/>
                        <Route path="reports" element={<HomeReportsScreen/>}/>
                        <Route path="reports/view/:reportNd" element={<HomeReportViewScreen/>}/>
                        <Route path="about" element={<HomeAboutScreen/>}/>
                        <Route path="bank" element={<HomeNahalBankScreen/>}/>
                        <Route path="gallery" element={<HomeGalleryScreen/>}/>
                        <Route path="honors" element={<HomeHonorsScreen/>}/>
                    </Route>
                    <Route path="/signup/login" element={<SignupLoginScreen/>}/>
                    <Route path="/signup/status" element={<SignupStatusScreen/>}/>
                    <Route path="/signup/invoice/:invoiceNd" element={<SignupInvoiceScreen/>}/>
                    <Route path="/signin/admin" element={<AdminsLoginScreen/>}/>
                    <Route path="/signin" element={<ParentsLoginScreen/>}/>
                    <Route path="/admins/" element={<AdminsDashboardArch/>}>
                        <Route path="" element={<RedirectTo to={"/admins/overview"} replace={true}/>}/>
                        <Route path="overview" element={<AdminsOverviewScreen/>}/>
                        <Route path="students" element={<AdminsStudentsListScreen/>}/>
                        <Route path="students/view/:studentId" element={<AdminStudentDetailsScreen/>}/>
                        <Route path="attend" element={<AdminAttendOverviewScreen/>}/>
                        <Route path="attend/reports" element={<AdminsAttendReportsScreen/>}/>
                        <Route path="attend/absents" element={<AdminsAttendAbsentsScreen/>}/>
                        <Route path="finance" element={<AdminFinanceScreen/>}/>
                        <Route path="finance/tuition" element={<AdminsFinanceTuitionPaymentsScreen/>}/>
                        <Route path="finance/tuition/online" element={<AdminsFinanceTuitionPaymentsOnlineScreen/>}/>
                        <Route path="finance/paid-full" element={<AdminFinanceThoseWhoPaidFullyScreen/>}/>
                        <Route path="finance/still-owe" element={<AdminFinanceThoseWhoStillOweScreen/>}/>
                        <Route path="finance/invoice-paid/:invoiceId"
                               element={<AdminsStudentsTuitionPaidInvoiceScreen/>}/>
                        <Route path="finance/reminders" element={<AdminsFinanceRemindersListScreen/>}/>
                        <Route path="finance/logs" element={<AdminsFinanceLogsListScreen/>}/>
                        <Route path="point" element={<RedirectTo to={"/admins/store"} replace={true}/>}/>
                        <Route path="store" element={<AdminStoreScreen/>}/>
                        <Route path="store/with-budget" element={<AdminsStoreListStudentsWithBudget/>}/>
                        <Route path="store/sales" element={<AdminsStoreListSalesScreen/>}/>
                        <Route path="store/onlines" element={<AdminsStoreListOnlinePaymentsScreen/>}/>
                        <Route path="news" element={<AdminNewsScreen/>}/>
                        <Route path="news/view/:newsId" element={<AdminsNewsDetailsScreen/>}/>
                        <Route path="website" element={<AdminWebsiteScreen/>}/>
                        <Route path="forms" element={<AdminFormsScreen/>}/>
                        <Route path="tickets" element={<AdminTicketsScreen/>}/>
                        <Route path="tickets/view/:ticketNd" element={<AdminsTicketViewScreen/>}/>
                        <Route path="settings" element={<AdminSettingsScreen/>}/>
                        <Route path="settings/users" element={<AdminUsersScreen/>}/>
                        <Route path="center" element={<AdminCenterScreen/>}/>
                        <Route path="center/class/:classId" element={<AdminsCenterClassDetailsScreen/>}/>
                        <Route path="classes" element={<AdminClassesScreen/>}/>
                        <Route path="extra" element={<AdminsExtraPaymentsListScreen/>}/>
                        <Route path="extra/view/:paymentId" element={<AdminsExtraPaymentViewScreen/>}/>
                        <Route path="consents" element={<AdminsConsentsListScreen/>}/>
                        <Route path="consents/view/:consentId" element={<AdminsConsentDetailsScreen/>}/>
                        <Route path="staff" element={<AdminsStaffScreen/>}/>
                        <Route path="staff/view/:staffId" element={<AdminsStaffDetailsScreen/>}/>
                        <Route path="staff/jobs" element={<AdminsStaffJobsScreen/>}/>
                        <Route path="staff/salaries" element={<AdminsStaffSalariesScreen/>}/>
                        <Route path="staff/requests" element={<AdminsStaffRequestsScreen/>}/>
                        <Route path="staff/requests/view/:requestId" element={<AdminsStaffRequestDetailsScreen/>}/>
                        <Route path="staff/hire" element={<AdminsStaffHireScreen/>}/>
                        <Route path="staff/hire/view/:jobId" element={<AdminsHireViewJobScreen/>}/>
                        <Route path="staff/attend" element={<AdminsStaffAttendOverview/>}/>
                        <Route path="staff/attend/list" element={<AdminsStaffAttendAbsentsScreen/>}/>
                        <Route path="presignup" element={<AdminsPresignupScreen/>}/>
                        <Route path="presignup/insights" element={<AdminsPresignupInsightsScreen/>}/>
                        <Route path="presignup/view/:studentId" element={<AdminsPresignupStudentDetails/>}/>
                        <Route path="consult" element={<AdminsConsultOverviewScreen/>}/>
                        <Route path="consult/requests" element={<AdminsConsultRequestsScreen/>}/>
                        <Route path="consult/requests/view/:requestId" element={<AdminsConsultRequestViewScreen/>}/>
                        <Route path="consult/profiles" element={<AdminsConsultProfilesList/>}/>
                        <Route path="consult/profiles/view/:studentId" element={<AdminsConsultProfileViewScreen/>}/>
                    </Route>
                    <Route path="/students/" element={<StudentsDashboardArch/>}>
                        <Route path="" element={<RedirectTo to={"/students/overview"} replace={true}/>}/>
                        <Route path="overview" element={<StudentsOverviewScreen/>}/>
                        <Route path="tuition" element={<StudentsTuitionScreen/>}/>
                        <Route path="tuition/pay/:invoiceNd" element={<StudentsTuitionPayInvoiceScreen/>}/>
                        <Route path="tuition/paid/:invoiceId" element={<StudentsTuitionPaidInvoiceScreen/>}/>
                        <Route path="store" element={<StudentsStoreScreen/>}/>
                        <Route path="store/invoice/:invoiceNd" element={<StudentsStoreInvoiceScreen/>}/>
                        <Route path="attend" element={<StudentsAttendScreen/>}/>
                        <Route path="news" element={<StudentsNewsScreen/>}/>
                        <Route path="news/view/:newsNd" element={<StudentsViewNewsScreen/>}/>
                        <Route path="tickets" element={<StudentsTicketsScreen/>}/>
                        <Route path="tickets/view/:ticketNd" element={<StudentsViewTicketScreen/>}/>
                        <Route path="center" element={<StudentsCenterScreen/>}/>
                        <Route path="center/class/:classNd" element={<StudentsCenterClassViewScreen/>}/>
                        <Route path="center/invoice/:invoiceNd" element={<StudentsSciCenterInvoiceScreen/>}/>
                        <Route path="extra/invoice/:invoiceNd" element={<StudentsExtraPaymentInvoiceScreen/>}/>
                        <Route path="consents" element={<StudentsConsentsListScreen/>}/>
                        <Route path="consents/view/:consentNd" element={<StudentsViewConsentScreen/>}/>
                        <Route path="profile" element={<StudentsProfileScreen isStandAlone={false}/>}/>
                        <Route path="presignup" element={<StudentsPresignupAutoLoginScreen/>}/>
                        <Route path="consult" element={<StudentsConsultOverviewScreen/>}/>
                        <Route path="consult/requests/view/:requestId" element={<ParentsConsultRequestViewScreen/>}/>
                    </Route>
                    <Route path="/finish-profile" element={<StudentsProfileScreen isStandAlone={true}/>}/>
                    <Route path="/print/admins/finance/tuition/:from/:to/:classId/:separatePages"
                           element={<AdminsPrintFinanceTuitionScreen/>}/>
                    <Route path="/print/admins/finance/paid-full" element={<AdminsPrintThoseWhoFullyPaid/>}/>
                    <Route path="/print/admins/finance/sill-owe/:classId" element={<AdminsPrintThoseWhoStillOwe/>}/>
                    <Route path="/print/admins/finance/reminders/:classId" element={<AdminPrintRemindersScreen/>}/>
                    <Route
                        path="/print/admins/students/:classId/:name/:grade/:national/:father/:birthSerial/:homeTell/:birthDate/:fatherCertificate/:fatherTell/:fatherJob/:motherName/:motherTell/:motherCertificate/:motherJob/:zipCode/:address/:budget/:maxBuyPerDay/:isInside/:className"
                        element={<AdminsPrintStudentByClassScreen/>}/>
                    <Route path="/print/admins/student-tuition/:studentId" element={<PrintStudentTuitionScreen/>}/>
                    <Route path="/print/admins/store/with-budget/:classId"
                           element={<AdminsPrintStudentsWithStoreBudget/>}/>
                    <Route path="/print/admins/store/sales/:from/:to/:classId"
                           element={<AdminsPrintStoreSalesScreen/>}/>
                    <Route path="/print/admins/store/online/:from/:to" element={<AdminsPrintStoreOnlinePayments/>}/>
                    <Route path="/print/admins/extra/:paymentId/:classId" element={<AdminsPrintExtraPaymentsScreen/>}/>
                    <Route path="/print/admins/consent/:consentId/:classId"
                           element={<AdminsPrintConsentSignupsScreen/>}/>
                    <Route path="/print/admins/consent-paper/:consentId/:classId"
                           element={<AdminsPrintConsentPaperScreen/>}/>
                    <Route path="/print/admins/signup" element={<AdminsSignupPrintStudents/>}/>
                    <Route path="/print/admins/staff/contract/:staffId" element={<AdminsStaffPrintContractScreen/>}/>
                    <Route path="*" element={<Error404Page/>}/>
                </Routes>
            </BrowserRouter>
        </>
    );
};